import { Routes, Route } from 'react-router-dom';
import AssessmentsIndex from './pages/AssessmentsIndex';
import AssessmentIntro from './pages/AssessmentIntro';
import AssessmentRunner from './pages/AssessmentRunner';
import AssessmentIntake from './pages/AssessmentIntake';
import AssessmentResult from './pages/AssessmentResult';
import AssessmentResume from './pages/AssessmentResume';
import NotFound from './pages/NotFound';

/**
 * The SPA mounts inside a Hugo-rendered page, so it owns content only —
 * no Header/Footer, no <main> wrapper, no horizontal layout (those come
 * from the Hugo chrome around the mount point).
 */
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<AssessmentsIndex />} />
      <Route path="/:slug/" element={<AssessmentIntro />} />
      <Route path="/:slug/q/:n/" element={<AssessmentRunner />} />
      <Route path="/:slug/intake/" element={<AssessmentIntake />} />
      <Route path="/:slug/result/:uuid/" element={<AssessmentResult />} />
      <Route path="/:slug/resume/:uuid/" element={<AssessmentResume />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
